import React from "react";
import { Invest } from "../Cards/Invest";
import { Deposite } from "../Deposite/Deposite";
import Withdraw from "../Withdraw/Withdraw";
import CurrencyDisplay from "../Currency/CurrencyDisplay";

export const Wallet = ({
  activeInvestment,
  expectedReturn,
  isHome,
  user,
  getUserInvestmentsLoading,
  investments,
}) => {
  return (
    <div className="w-full flex flex-col gap-2 font-sans">
      {/* --- Top Blue Wallet Card --- */}
      <div className="relative w-full rounded-[1rem] text-white px-6 pb-1  overflow-hidden">
        <div
          className="absolute inset-0 w-full h-full pointer-events-none"
          style={{
            backgroundImage: "url('/img/new/background/africa-map.jpeg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Header Row */}
        <div className="relative z-10 flex justify-between items-center pt-6">
          <div className="flex items-center gap-2">
            <span className="text-[13px] text-blue-100 font-medium">
              Total Balance
            </span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-blue-100"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
          </div>
        </div>

        {/* Main Balance Area */}
        <div className="relative z-10 mt-1 mb-8">
          <h2 className="text-[2.5rem] leading-none font-semibold tracking-tight mb-2">
            {/* Replace this hardcoded value with your CurrencyDisplay component when ready */}
            <CurrencyDisplay
              usdAmount={user.balance}
              className="inline"
              showCurrency={true}
            />
          </h2>
        </div>

        {/* Bottom Stats Row */}
        <div className="relative z-10 flex items-center justify-between py-4 backdrop-blur-sm border-t border-t-white/10">
          {/* Available Balance */}

          {/* Active Invested */}
          <div className="flex flex-row items-start gap-2 flex-1">
            <div className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center text-white shrink-0">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="20" x2="18" y2="10"></line>
                <line x1="12" y1="20" x2="12" y2="4"></line>
                <line x1="6" y1="20" x2="6" y2="14"></line>
              </svg>
            </div>
            <div>
              <p className="text-[10px] text-blue-100 font-medium mb-0.5 whitespace-nowrap">
                Active Invested
              </p>
              <p className="text-[13px] font-semibold">
                <CurrencyDisplay
                  usdAmount={activeInvestment}
                  className="inline"
                  showCurrency={true}
                />
              </p>
            </div>
          </div>

          <div className="w-px h-10 bg-white/10 mx-2"></div>

          {/* Total Returns */}
          <div className="flex flex-row items-start gap-2 flex-1 pl-1">
            <div className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center text-white shrink-0">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="16"></line>
                <line x1="8" y1="12" x2="16" y2="12"></line>
              </svg>
            </div>
            <div>
              <p className="text-[10px] text-blue-100 font-medium mb-0.5 whitespace-nowrap">
                Total Returns
              </p>
              <p className="text-[13px] font-semibold">
                <CurrencyDisplay
                  usdAmount={expectedReturn}
                  className="inline"
                  showCurrency={true}
                />
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* --- Action Buttons Container --- */}
      <div className="flex items-stretch rounded-[1rem] bg-white shadow-[0_4px_15px_rgb(0,0,0,0.04)] border border-gray-100 relative">
        {/* Fund Button */}
        <div className="flex-1">
          <Deposite fromWallet={true} />
        </div>

        <div className="w-px self-stretch bg-gray-100 shrink-0"></div>

        <div className="flex-1">
          <Withdraw fromWallet={true} />
        </div>

        <div className="w-px self-stretch bg-gray-100 shrink-0"></div>

        <div className="flex-1">
          <Invest fromWallet={true} />
        </div>
      </div>
    </div>
  );
};
